export const STATUS_STAKED = 0;
export const STATUS_CLAIMED = 1;
export const STATUS_MIGRATING = 2;
export const STATUS_MIGRATED = 3;


